import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import APP from 'app'
import { Avatar, Image } from 'images'

const renderBrand = () => (
  <Image className="shrink" src={`${APP.url}/img/sweatbits-black.png`} styles={{ height: 40, width: 200 }} />
)

class BlockTitle extends PureComponent {
  renderImage = () => <Avatar className="shrink" size="2em" src={this.props.image} />

  render() {
    const { children, className, image, printable, title } = this.props
    return (
      <div className={classnames('flex items-center gap-2 p-2', className)}>
        {image && this.renderImage()}
        <div className={classnames('grow text-xl font-bold', !!title && !children && 'leading-4 line-clamp-2')}>
          {title || children}
        </div>
        {printable && renderBrand()}
      </div>
    )
  }
}

BlockTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
  printable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default BlockTitle
